import { fork, takeEvery } from 'typed-redux-saga';
import { placeCurrentCartsRequestedType } from '../../carts/cartsSlice';
import placeCurrentCartsTrackingSaga from './placeCurrentCartsTrackingSaga';
import watchCartActionsTrackingSaga from './watchCartActionsTrackingSaga';

function* watchCurrentCartActionsTrackingSaga(): Generator {
  yield* fork(watchCartActionsTrackingSaga);
  yield* takeEvery(placeCurrentCartsRequestedType, placeCurrentCartsTrackingSaga);
}

export default watchCurrentCartActionsTrackingSaga;
